/**
 * Store registry — signing/NDA (B✕): framework-owned signing/NDA stores that
 * are NOT part of the Dyrejournal build (decision 2026-07-05, manifest §9).
 * Same excisable treatment as the C registries, kept in its own group so the
 * ownership mapping stays clean.
 *
 * The Dyrejournal-repo export replaces this file with an empty stub
 * (`export default {};`) and removes the imported store files. Everything that
 * consumes these stores from app-level code must therefore access them
 * guarded: `signingStores.formSigningRequestStore?.method()`.
 * Classification source of truth: docs/dyrejournal-separation/manifest.md
 */
import ndaDocumentStore from '../stores/ndaDocument';
import ndaAcceptanceStore from '../stores/ndaAcceptance';
import formSigningRequestStore from '../stores/formSigningRequest';
import signRequestStore from '../stores/signRequest';

export default {
    ndaDocumentStore,
    ndaAcceptanceStore,
    formSigningRequestStore,
    signRequestStore,
};
